import React from 'react';
import { useContent } from './ContentContext';
import { supabase } from '../lib/supabase';

/** Floating control bar shown only when the owner is logged in. */
export default function EditToolbar() {
  const { isOwner, editMode, setEditMode } = useContent();
  if (!isOwner) return null;

  return (
    <div className="fixed bottom-4 left-1/2 z-[9998] flex -translate-x-1/2 items-center gap-3 rounded-full bg-[#061E35] px-4 py-2.5 text-white shadow-2xl ring-1 ring-white/15">
      <span className="text-xs font-semibold">
        {editMode ? 'Editing mode — click any text or image' : 'Viewing site'}
      </span>
      <button
        onClick={() => setEditMode(!editMode)}
        className={`rounded-full px-3 py-1.5 text-xs font-semibold transition-colors ${
          editMode ? 'bg-[#1FA8F5] text-white' : 'bg-white/15 text-white hover:bg-white/25'
        }`}
      >
        {editMode ? 'Done editing' : 'Edit page'}
      </button>
      <button
        onClick={() => supabase?.auth.signOut()}
        className="rounded-full px-3 py-1.5 text-xs font-medium text-white/70 hover:text-white"
      >
        Log out
      </button>
    </div>
  );
}
